import { ActivityController } from "@/controllers/model-controllers/activity-controller"
import { useActivityStore } from "@/store/activity.store"

export class AppActivityController extends ActivityController {
  constructor() {
    const activityStore = useActivityStore()
    const { pushToRelatedAppWorkPeriod, removeFromRelatedAppWorkPeriod } = activityStore
    const storeFunctionsConfig = {
      onCreate: pushToRelatedAppWorkPeriod,
      onDelete: removeFromRelatedAppWorkPeriod,
      managed: false
    }
    super(storeFunctionsConfig)
  }
}
